import type { FaireProductEntity } from "../../entity_types/product";

export const p_6565k3j9h8: FaireProductEntity = {
  token: "p_6565k3j9h8",
  type: "product",
  name: "Perfect Feminine yoni oil spray(10 Pack)",
  brandToken: "b_mjd9qy3dnh",
  brandName: "VIGOR",
  imageUrl:
    "https://cdn.faire.com/fastly/d40279b0691fe558405c537f7bb2e5afbfb8627a2538b9af915c2412f7460a1a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6fd40f2afd06aef48e73a55ff9993fdb15c5899e3ed72f3c6f70c5fade691bac.jpeg",
    "https://cdn.faire.com/fastly/6796d8e6425f9cef04fd9b1f8e7f3aa641df1af85ccd081ac53ccb355cf4bef8.jpeg",
    "https://cdn.faire.com/fastly/5c205997bbf4e69051ba05569ae3951489c8733c03655f747da89486bc6315f6.jpeg",
    "https://cdn.faire.com/fastly/49f922a5f575c215c45729503860ee9a737a77feb80c92fd55114c95543c6845.jpeg",
    "https://cdn.faire.com/fastly/2345518fad6b9137bdbd367b522bba8fa43ca2de8a81096e0a0a1c7b53abc6fe.jpeg",
    "https://cdn.faire.com/fastly/42563688e6029c9813ad044c517ffb89d26b4dd67125cc751361c8b0a121d718.jpeg",
    "https://cdn.faire.com/fastly/c0373a002be640bd57f3001a8b01ae0c0744ea2bf2f04094264761d66d8973f2.jpeg",
    "https://cdn.faire.com/fastly/d29e27975fe0c3dc7bd541d7ab6fbde853b9857aac2cc168cddd562d9f24169a.jpeg",
    "https://cdn.faire.com/fastly/7f49f4ac89a6b25a7acd3f3a2590919211a5993ec993f1a0912d896a5db3ee0a.jpeg",
    "https://cdn.faire.com/fastly/96bacc523316155928303adbff63161771630de62cd10605c5187a6c33469adc.jpeg",
    "https://cdn.faire.com/fastly/fc8a274630af33d6776b132e6302bd335a5c385e806be929e156146d6f300703.jpeg",
    "https://cdn.faire.com/fastly/7964f38b6616b34ca68dd97218bad5c1e752a7b7768d0f45652f4fbb0a4479fb.jpeg",
  ],
  priceDollars: 18,
  description:
    "100% natural yoni mist Odor Fast Clean Yoni Spray\n\nyoni spray Made with Tea Tree Lemongrass and Orange Essential Oil\n\nSuitable for cleaning,female vulva, inhibiting germs, removing odor, itching, etc.\n\nProvides moisturizing to the vagina anti bacterial & anti inflmmatory.\n****************************************************************************\nPackage Includes:\n\nEach pack Contains 1 Item based on your check out count of selection\n******************************************************************************",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:13.658Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
